import { Status } from './status';

/** Money is out or on its way, so the authorization can't be reversed anymore. */
export const SENT_STATUSES = [Status.ISSUED, Status.COMPLETED];

/** Payments not paid out yet; a new-flow claim can't close while it has any. */
export const UNPAID_STATUSES = [Status.DRAFT, Status.ISSUED];

/** Payments that hold part of the authorized amount; FAILED and VOIDED release it. */
export const RESERVING_STATUSES = [Status.DRAFT, Status.ISSUED, Status.COMPLETED];

/** What an authorization has paid and has left, in cents. */
export interface Balance {
  authorizationId: string;
  authorizationReference: string;

  /** The authorization's net payable. */
  authorizedPayable: number;

  /** COMPLETED payments. */
  paid: number;

  /** DRAFT, ISSUED and COMPLETED payments. */
  reserved: number;

  /** What new payments can still use. */
  remaining: number;
}

/** The one rule the API and the claim views use. Pass only the authorization's own payments. */
export function getBalance(
  authorization: { id: string; reference: string; netPayable: number },
  payments: { status: Status; amount: number }[]
): Balance {
  const sum = (statuses: Status[]) =>
    payments.filter(payment => statuses.includes(payment.status)).reduce((total, payment) => total + payment.amount, 0);

  const reserved = sum(RESERVING_STATUSES);

  return {
    authorizationId: authorization.id,
    authorizationReference: authorization.reference,
    authorizedPayable: authorization.netPayable,
    paid: sum([Status.COMPLETED]),
    reserved,
    remaining: authorization.netPayable - reserved,
  };
}
